@use '@/scss/underscore' as _;

.main {
  .row {
    display: flex;
    align-items: center;
    border: 1px solid var(--color-divider);
    border-radius: _.unit(2);
    padding: _.unit(3) _.unit(4);

    .icon {
      margin-right: _.unit(6);
    }

    &:not(:last-child) {
      margin-bottom: _.unit(6);
    }

    .text {
      flex: 1;

      .title {
        font: var(--font-title-3);
        color: var(--color-text);
      }

      .description {
        font: var(--font-body-2);
        color: var(--color-text-secondary);
      }
    }

    .button {
      width: 90px;
    }
  }
}
